import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import { useCreateArticleRelationGroupMutation } from 'services';

/**
 * İlişki grubu oluşturma işlemini yönetir.
 *
 * - Başarılıysa: Oluşturulan grubun düzenleme ekranına yönlendirir.
 * - 422 ise: Aynı kaynağa ait ilişki grubu zaten mevcut; mevcut grubun düzenleme ekranına yönlendirir.
 * - Diğer hatalarda: Kullanıcıya hata bildirimi gösterir.
 *
 * @returns {{ onSelect: (option: { value: string, entryId: string, article: { type: string } }) => Promise<void>, isLoading: boolean }}
 */
function useCreateRelationGroup() {
  const [createNewRelationGroup, { isLoading }] = useCreateArticleRelationGroupMutation();
  const navigate = useNavigate();

  const onSelect = async (option) => {
    const { value, entryId, article } = option;
    const relationEditPath = `/madde-iliskilendirme-yonetimi/duzenle/${value}`;

    const { error } = await createNewRelationGroup({
      sourceType: article.type,
      sourceId: entryId,
      hasNoRelation: false,
      hasChecked: false,
      // burdaki item alani maddeleri local state de tutmamak icin bu sekilde set edildi bu sayede
      // invalidate edildiginde bu alan olusturuldugundan dolayi direk islem yapmaya devam edilebilir
      items: [],
    });

    if (error) {
      if (error.status === 422) {
        return navigate(relationEditPath);
      }

      return notification.error({
        message: 'Hata',
        description: error.data['hydra:description'] || 'Bir hata oluştu, lütfen tekrar deneyiniz.',
      });
    }

    navigate(relationEditPath);
  };

  return { onSelect, isLoading };
}

export default useCreateRelationGroup;
